import type { SVGProps } from 'react';
const SvgImport = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 16 16"
    height={16}
    fill="none"
    width={16}
    {...props}
  >
    <g clipPath="url(#Import_svg__a)">
      <path
        d="M14.646 11.757v1.156a1.734 1.734 0 0 1-1.733 1.733H3.088a1.734 1.734 0 0 1-1.734-1.733v-1.156M8 11.69V1.354m0 10.337 4.23-4.23M8 11.69 3.77 7.46"
        strokeLinejoin="round"
        stroke="currentColor"
        strokeLinecap="round"
        strokeWidth={1.5}
      />
    </g>
    <defs>
      <clipPath id="Import_svg__a">
        <path d="M0 0h16v16H0z" fill="#fff" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgImport;
